<app-new-business-hero-header [queryParams]="queryParams"></app-new-business-hero-header>
<app-common-companies-panel
  [companiesData]="companiesData"
></app-common-companies-panel>
<app-multi-currency [queryParams]="queryParams"></app-multi-currency>
<app-global-reach [queryParams]="queryParams"></app-global-reach>
<app-efficient-payment></app-efficient-payment>
<app-common-international-business
  [IBData]="ibData"
></app-common-international-business>
<app-common-discover-why
  [discoverData]="discoverData"
></app-common-discover-why>
<app-common-faq [faqData]="faqData"></app-common-faq>
<app-common-latest-news
  [blogData]="newsList"
  [isWhiteBg]="true"
></app-common-latest-news>
<app-common-ready-to [readyToData]="readyToData"></app-common-ready-to>
<app-common-explore-global-panel
  [exploreData]="exploreMore"
></app-common-explore-global-panel>
